import { render } from "./plano.vue?vue&type=template&id=5873c08f&scoped=true"
const script = {}

import "./plano.vue?vue&type=style&index=0&id=5873c08f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5873c08f"]])

export default __exports__